import { Button, Container, FormControl, InputLabel, MenuItem, Pagination, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import DocumentItem from "../../components/DocumentItem";
import { Backend } from "../../services/Backend";
import { isUserLoggedIn, userHasPermissions } from "../../utils/utils";
import { UserPermissions } from "../../dto/Permissions";
import { Oval } from "react-loader-spinner";
import Loader from "../../components/Loader";
import { useSearchParams } from "react-router-dom";

export default function SearchDocsPage() {
    const [searchParams, setSearchParams] = useSearchParams();

    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [foundDocuments, setFoundDocuments] = useState(0);
    const [searchQuery, setSearchQuery] = useState(searchParams.get('search') ? searchParams.get('search') : "");

    const [interest, setInterest] = useState("");
    const [language, setLanguage] = useState("");
    const [publisher, setPublisher] = useState("");
    const [disciplinaryContext, setDisciplinaryContext] = useState("");
    const [format, setFormat] = useState("");


    const [sortBy, setSortBy] = useState("none");
    const [orderBy, setOrderBy] = useState("asc");
    const [data, setData] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [urls, setUrls] = useState([]);

    const [showFilters, setShowFilters] = useState(false);

    const fetchDocuments = (body) => {
        Backend.post(`document/search/with-url`, body)
            .then(res => {
                const documents = []; 
                const urls = []; 

                res.data.forEach(item => item.publisher ? documents.push(item) : urls.push(item));
                setDocuments(documents);
                setUrls(urls);

                // setData();
                setFoundDocuments(res.totalCount);
                setIsLoading(false);
                if (res.data.length > 0)
                    setTotalPages(Math.ceil(res.totalCount / res.data.length))
            });
    }
    const fetchDocumentsWithFilters = (currentPage = page) => {
        const body = {
            interest,
            language,
            publisher,
            disciplinaryContext,
            format,
            page: currentPage - 1,
            title: searchQuery,
            sortBy: "rating_desc"
        };

        fetchDocuments(body);
    }

    useEffect(() => {
        fetchDocumentsWithFilters();

        userHasPermissions(UserPermissions.SearchWithCriteria)
            .then(res => setShowFilters(res));
    }, []);


    const handlePageChange = (e, newPage) => {
        setPage(newPage);
        
        const body = {
            interest,
            language,
            publisher,
            format,
            disciplinaryContext,
            page: newPage - 1,
            title: searchQuery,
            sortBy: "rating_desc",
        };

        Backend.post(`document/search/with-url`, body)
            .then(res => {
                // setData(res.data)
                const documents = []; 
                const urls = []; 

                res.data.forEach(item => item.publisher ? documents.push(item) : urls.push(item));
                setDocuments(documents);
                setUrls(urls);
            });
    }

    const handleSearch = () => {
        fetchDocumentsWithFilters(1);
    }
    
    const resetFilters = () => {
        setInterest("");
        setLanguage("");
        setDisciplinaryContext("");
        setPublisher("");
        setFormat("");
        setSortBy("none");
        setOrderBy("asc");
        setSearchQuery("");
        setPage(1);

        const body = {
            interest: "",
            language: "",
            publisher: "",
            format: "",
            disciplinaryContext: "",
            page: 0,
            title: "",
            sortBy: "rating_desc"
        };

        fetchDocuments(body);
    }

    return <Container maxWidth="lg" className="my-5">
         <div className="flex gap-3">
            <TextField margin="normal" size="small" required fullWidth label="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}  />
            <Button  variant="contained" sx={{ mt: 2, mb: 1 }} onClick={handleSearch}>Search</Button>
        </div>
        {showFilters ? <>
            <div className="flex gap-3  items-center">
            <TextField margin="normal" label="Publisher" size="small" value={publisher} onChange={(e) => setPublisher(e.target.value)} /> 
            <FormControl  sx={{ width: "200px"}} margin="normal" size="small">
                <InputLabel>Interest</InputLabel>
                <Select
                    label="Interest"
                    size="small"
                    margin="normal"
                    value={interest}
                    onChange={(e) => setInterest(e.target.value)}
                >
                    <MenuItem value="Transport safety">Transport safety</MenuItem>
                    <MenuItem value="Industrial safety">Industrial safety</MenuItem>
                    <MenuItem value="Chemical warehousing">Chemical warehousing</MenuItem>
                    <MenuItem value="Tank storage">Tank storage</MenuItem>
                </Select>
            </FormControl>
            <FormControl  sx={{ width: "200px"}} margin="normal" size="small">
                <InputLabel>Language</InputLabel>
                <Select
                    label="Language"
                    size="small"
                    margin="normal"
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                >
                    <MenuItem value="English">English</MenuItem>
                    <MenuItem value="Dutch">Dutch</MenuItem>
                    <MenuItem value="German">German</MenuItem>
                    <MenuItem value="Spanish">Spanish</MenuItem>
                    <MenuItem value="French">French</MenuItem>
                    <MenuItem value="Chinese">Chinese</MenuItem>
                </Select>
            </FormControl>
            <FormControl  sx={{ width: "200px"}} margin="normal" size="small">
                <InputLabel>Disciplinary context</InputLabel>
                <Select
                    label="Disciplinary context"
                    size="small"
                    margin="normal"
                    value={disciplinaryContext}
                    onChange={(e) => setDisciplinaryContext(e.target.value)}
                >
                    <MenuItem value="Normative">Normative</MenuItem>
                    <MenuItem value="Scientific">Scientific</MenuItem>
                    <MenuItem value="Tools and techniques">Tools and techniques</MenuItem>
                    <MenuItem value="Legislative">Legislative</MenuItem>
                </Select>
            </FormControl>
            <FormControl  sx={{ width: "200px"}} margin="normal" size="small">
                <InputLabel>Format</InputLabel>
                <Select
                    label="Format"
                    size="small"
                    margin="normal"
                    value={format}
                    onChange={(e) => setFormat(e.target.value)}
                >
                    <MenuItem value="pdf">PDF</MenuItem>
                    <MenuItem value="docx">DOCX</MenuItem>
                    <MenuItem value="doc">DOC</MenuItem>
                </Select>
            </FormControl>
        </div>
        <Button variant="contained" color="error" onClick={resetFilters}>Reset</Button>
        </> : ""}
        
        <p className="my-2">Found <b>{foundDocuments}</b> documents {!isUserLoggedIn() ? " - Get a Free account and check out these Best practices" : ""}</p>
        <hr />

        {isLoading ? <div className="mx-auto w-fit mt-4">
            <Loader />
            </div> : <>
                <div className="mt-2">
                    {/* {data.map(item => <DocumentItem data={item} linkTo={`/best-practice/${item.id}`} />)} */}
                    {documents.map(item => <DocumentItem data={item} linkTo={`/best-practice/${item.id}`} />)}
                    {urls.map(item => <DocumentItem data={item} linkTo={`/url/${item.id}`} />)}
                </div> 
                <Pagination count={totalPages} color="primary"  page={page} onChange={handlePageChange} />
            </>
        }
    </Container>
}